import React, { useState, useEffect, useContext } from "react";

import { Avatar, CardHeader } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import getTicketDisplayName from "../../utils/getTicketDisplayName";
import { AuthContext } from "../../context/Auth/AuthContext";

const TicketInfo = ({ contact, ticket, onClick }) => {
  const { user } = ticket;
  const { user: currentUser } = useContext(AuthContext);
  const [userName, setUserName] = useState("");
  const [contactName, setContactName] = useState("");
  const isInternalTicket = Boolean(ticket?.isInternal);
  const profilePicUrl = isInternalTicket
    ? "/nopicture.png"
    : (contact?.profilePicUrl ?? "");

  useEffect(() => {
    if (ticket) {
       const formattedName = getTicketDisplayName(ticket, currentUser?.id);
      let displayName = formattedName;

      if (document.body.offsetWidth < 600) {
        if (formattedName.length > 10) {
          const truncadName = formattedName.substring(0, 10) + "...";
          displayName = truncadName;
        }
      }

      setContactName(displayName);
    }

    if (user && ticket) {
      setUserName(`${i18n.t("messagesList.header.assignedTo")} ${user.name}`);

      if (document.body.offsetWidth < 600) {
        setUserName(`${user.name}`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CardHeader
      onClick={onClick}
      style={{ cursor: "pointer" }}
      titleTypographyProps={{ noWrap: true }}
      subheaderTypographyProps={{ noWrap: true }}
      avatar={
        <Avatar
          src={profilePicUrl}
          alt="contact_image"
          imgProps={{
            onError: (e) => {
              e.target.onerror = null;
              e.target.src = "/nopicture.png";
            },
          }}
        />
      }
      title={`${contactName} #${ticket.id}`}
      subheader={ticket.user && `${userName}`}
    />
  );
};

export default TicketInfo;
